import { log } from "./debug";

const capitalizeFistLetter=(word)=>{
    return word.charAt(0).toUpperCase() + word.slice(1);
}

const getPayMethods = (paymentOptions)=>{
  // payments are disable 
  if(!paymentOptions?.active)
      return null; 
  // olversion of payments
  let paymentMethods = [] 
  if((paymentOptions?.methods?.length>0)===true
    && !paymentOptions?.payMethods){
      paymentMethods = paymentOptions?.methods.map((it)=> {
        return {id:it}
      });
      return paymentMethods;
  }  

  //new version ok
  if(paymentOptions?.payMethods?.length>0){
    paymentMethods = paymentOptions.payMethods
    return paymentMethods;
  }
return null
}

function getPaymentMethods(location, view, language){
  let paymethods = location.takeorder?.paymentOptions
  if(view === "LOCAL"){
    paymethods = location.selforder?.paymentOptions
  }
  return getDisplayMethods(paymethods,language)
}

function getDisplayMethods(paymentOptions, language){
  let paymentList = getPayMethods(paymentOptions); 
  if(!paymentList) return null; 
  const payMethods =  paymentList.map( it=> toLocalPayment(it,language)); 
  log.message("Pay","parsePayMethods payMethods: ",payMethods);
  return payMethods; 
}



function toLocalPayment(payment,language){
  const name = payment.name? payment.name:getDefaultDisplayName(payment.id,language);
  const iconUrl = payment.iconUrl? payment.iconUrl: getDefaultIconUrl(payment.id)
  const paymentInfo = payment.paymentInfo? payment.paymentInfo : getDefaultPaymentInfo(payment); 
  return {
    id:payment.id,
    name:name,
    iconUrl:iconUrl,
    paymentInfo:paymentInfo,
    checked:false
  }
}

function getDefaultDisplayName(id,language){
  const displayPayment =  defaultOldPayment.find(it=> it.id === id.toUpperCase());
  if(displayPayment?.name) return displayPayment.name

  const localName = displayPayment?.nameLocal; 
  if(!localName || !language)
       return capitalizeFistLetter(id.toLowerCase());

 const nameMap = new Map(Object.entries(localName));
 const displayName = nameMap.get(language)?  nameMap.get(language):  nameMap.get("en");
 return displayName? displayName :  capitalizeFistLetter(id.toLowerCase());
}


function getDefaultPaymentInfo(remote){
  if(remote.id.toUpperCase() === "CASH" && remote?.inputValue===true){
    return {
      cashChange:true
    }
  }
  return null
}

function getDefaultIconUrl(id){
  const displayPayment =  defaultOldPayment.find(it=> it.id === id.toUpperCase());
  if(displayPayment?.iconUrl) return displayPayment?.iconUrl
  return "https://res.cloudinary.com/wikimenu/image/upload/v1715944170/store-app/pay/payment_lrcrxy.png"
}



const defaultOldPayment = [
  {
    "id": "CASH",
    "nameLocal": {
      "en": "Cash",
      "es": "Dinero",
      "pt": "Dinheiro"
    },
    "iconUrl": "https://res.cloudinary.com/wikimenu/image/upload/v1715944169/store-app/pay/cash_xcluq1.png"
  },
  {
    "id": "BANK_TRANSFER",
    "nameLocal": {
      "en": "Bank transfer",
      "es": "Transferencia bancaria",
      "pt": "Transferência bancária"
    },
    "iconUrl": "https://res.cloudinary.com/wikimenu/image/upload/v1715944169/store-app/pay/bank_ihghqo.png",
  },
  {
    "id": "PAYMENT_LINK",
    "nameLocal": {
      "en": "Payment link",
      "es": "Enlace de pago",
      "pt": "Link de pagamento"
    },
    "iconUrl": "https://res.cloudinary.com/wikimenu/image/upload/v1716715772/store-app/pay/link_mojjzl.png"
  },
  {
    "id": "CARD",
    "nameLocal": {
      "en": "Card",
      "es": "Tarjeta",
      "pt": "Cartão"
    },
    "iconUrl": "https://res.cloudinary.com/wikimenu/image/upload/v1715944169/store-app/pay/card_yy4lmc.png"
  },
  {
    "id": "BIZUM",
    "name": "Bizum",
    "iconUrl": "https://res.cloudinary.com/wikimenu/image/upload/v1716717075/store-app/pay/bizum_rounded_xyn54s.png"
  },

  {
    "id": "PIX",
    "name": "Pix",
    "iconUrl": "https://res.cloudinary.com/wikimenu/image/upload/v1715944170/store-app/pay/pix_kiivdy.png"
  },
  {
    "id": "PICPAY",
    "name": "PicPay",
    "iconUrl": "https://res.cloudinary.com/wikimenu/image/upload/v1716206574/store-app/pay/picpay_rtv7kf.png"
  },
  
];


export {
  getPaymentMethods, 
}
